// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Prodo_wrapper__YJeOV","disclaimer":"Prodo_disclaimer__S6w7I"};